import React from 'react';
import { SAMSDASSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'days-at-sea';

interface DaysAtSeaData {
  samsInputDAS?: number;
  dbSamsInputDAS?: number;
  updatingParams?: boolean;
}

export default function DaysAtSea(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<DaysAtSeaData>(props);

  const dbSamsInputDAS = data.dbSamsInputDAS ?? 24;
  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const samsInputDAS = formValue ?? data.samsInputDAS ?? dbSamsInputDAS ?? 24;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = parseFloat(e.target.value);
      formContext?.setValue(SLUG, newValue);
    },
    [formContext]
  );

  return (
    <SAMSDASSlider
      samsInputDAS={samsInputDAS}
      dbSamsInputDAS={dbSamsInputDAS}
      handleSamsDASChange={handleChange}
      updatingParams={data.updatingParams ?? false}
    />
  );
}
